import { render, staticRenderFns } from "./SingUpForm.vue?vue&type=template&id=10750be4&scoped=true"
import script from "./SingUpForm.vue?vue&type=script&lang=js"
export * from "./SingUpForm.vue?vue&type=script&lang=js"
import style0 from "./SingUpForm.vue?vue&type=style&index=0&id=10750be4&prod&lang=scss&scoped=true"
import style1 from "./SingUpForm.vue?vue&type=style&index=1&id=10750be4&prod&lang=css"
import style2 from "./SingUpForm.vue?vue&type=style&index=2&id=10750be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10750be4",
  null
  
)

export default component.exports